module.exports = __webpack_public_path__ + "img/edit-session-list.a96deb3b.svg";